// extracted by mini-css-extract-plugin
export var errorIcon = "_ik-1";
export var nameLogo = "_ik-0";